import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import { SendRequestModel } from '../../../plugins/models/SendRequestModel'
import TaskUpdateDescriptionRequest from '../../../projects/task/i-service/models/task/request/edit/TaskUpdateDescriptionRequest';
import TaskUpdateNameRequest from '../../../projects/task/i-service/models/task/request/edit/TaskUpdateNameRequest';
import TaskUpdatePriorityRequest from '../../../projects/task/i-service/models/task/request/edit/TaskUpdatePriorityRequest';
import UpdateDifficultyRequest from '../../../projects/task/i-service/models/task/request/UpdateDifficultyRequest';
import TaskUpdateStatusRequest from '../../../projects/task/i-service/models/task/request/edit/TaskUpdateStatusRequest';
import UpdateTaskTypeRequest from '../../../projects/task/i-service/models/task/request/UpdateTaskTypeRequest';
import TaskUpdateNumberRequest from '../../../projects/task/i-service/models/task/request/edit/TaskUpdateNumberRequest';
import TaskUpdateDateEndRequest from '../../../projects/task/i-service/models/task/request/edit/TaskUpdateDateEndRequest';
import TaskCreateRequest from '../../../projects/task/i-service/models/task/request/TaskCreateRequest';
import TaskRemoveRequest from '../../../projects/task/i-service/models/task/request/TaskRemoveRequest';
import TaskUpdateSprintRequest from '../../../projects/task/i-service/models/task/request/edit/TaskUpdateSprintRequest';
import PerformersUpdateRequest from '../../../projects/task/i-service/models/task/request/PerformersUpdateRequest';
import ObserverUpdateRequest from '../../../projects/task/i-service/models/observer/request/ObserverUpdateRequest';
import AddTagsRequest from '../../../projects/task/i-service/models/tag/request/AddTagsRequest';
import EstimatePerformerSaveRequest from '../../../projects/task/i-service/models/task/request/EstimatePerformerSaveRequest';
import AttachFileTaskRequest from '../../../projects/task/i-service/models/task/request/file/AttachFileTaskRequest';
import RemoveFilesTaskRequest from '../../../projects/task/i-service/models/task/request/file/RemoveFilesTaskRequest';
import RemoveSubtaskRequest from '../../../projects/task/i-service/models/task/request/RemoveSubtaskRequest';
import AttachSubtaskRequest from '../../../projects/task/i-service/models/task/request/AttachSubtaskRequest';
import WsResponseModelT from '../../../schema-builder-server/models/WsResponseModelT';
import TaskCreateResponse from '../../../projects/task/i-service/models/task/response/TaskCreateResponse';
import TaskShortInfo from '../../../projects/task/i-service/models/TaskShortInfo';

export default class ProjectTaskSaveService {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	UpdateDescriptionEvent = new Events<WsResponseModelT<Boolean>>();
	UpdateNameEvent = new Events<WsResponseModelT<Boolean>>();
	UpdatePriorityEvent = new Events<WsResponseModelT<Boolean>>();
	UpdateDifficultyEvent = new Events<WsResponseModelT<Boolean>>();
	UpdateStatusEvent = new Events<WsResponseModelT<Boolean>>();
	UpdateTaskTypeEvent = new Events<WsResponseModelT<Boolean>>();
	UpdateNumberEvent = new Events<WsResponseModelT<Boolean>>();
	UpdateDateEndEvent = new Events<WsResponseModelT<Boolean>>();
	TaskCreateEvent = new Events<WsResponseModelT<TaskCreateResponse>>();
	RemoveEvent = new Events<WsResponseModelT<Boolean>>();
	UpdateSprintEvent = new Events<WsResponseModelT<Boolean>>();
	UpdatePerformersEvent = new Events<WsResponseModelT<Boolean>>();
	UpdateObserverEvent = new Events<WsResponseModelT<Boolean>>();
	UpdateTagsInTaskEvent = new Events<WsResponseModelT<Boolean>>();
	UpsertEstimatePerformerEvent = new Events<WsResponseModelT<Boolean>>();
	AddFileEvent = new Events<WsResponseModelT<String>>();
	RemoveFilesEvent = new Events<WsResponseModelT<Boolean>>();
	RemoveSubtaskEvent = new Events<WsResponseModelT<Boolean>>();
	AttachSubtaskEvent = new Events<WsResponseModelT<TaskShortInfo>>();

	subscribeEvents = async () => {
		const self = this;
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		webApiService.on('ProjectTaskSaveService', 'UpdateDescription', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.UpdateDescriptionEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'UpdateName', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.UpdateNameEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'UpdatePriority', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.UpdatePriorityEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'UpdateDifficulty', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.UpdateDifficultyEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'UpdateStatus', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.UpdateStatusEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'UpdateTaskType', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.UpdateTaskTypeEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'UpdateNumber', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.UpdateNumberEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'UpdateDateEnd', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.UpdateDateEndEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'TaskCreate', 'Main', (res: WsResponseModelT<TaskCreateResponse>) => {
			self.TaskCreateEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'Remove', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.RemoveEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'UpdateSprint', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.UpdateSprintEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'UpdatePerformers', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.UpdatePerformersEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'UpdateObserver', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.UpdateObserverEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'UpdateTagsInTask', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.UpdateTagsInTaskEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'UpsertEstimatePerformer', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.UpsertEstimatePerformerEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'AddFile', 'Main', (res: WsResponseModelT<String>) => {
			self.AddFileEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'RemoveFiles', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.RemoveFilesEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'RemoveSubtask', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.RemoveSubtaskEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'AttachSubtask', 'Main', (res: WsResponseModelT<TaskShortInfo>) => {
			self.AttachSubtaskEvent.trigger(res);
		});
	}

	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
		this.subscribeEvents();
	}

	/**
	 * * Изменить описание
	 */
	async UpdateDescription(query: TaskUpdateDescriptionRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'UpdateDescription',
			Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Изменить название задачи
	 */
	async UpdateName(query: TaskUpdateNameRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'UpdateName',
			Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Изменить приоритет
	 */
	async UpdatePriority(query: TaskUpdatePriorityRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'UpdatePriority',
			Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Обновление сложности задачи
	 */
	async UpdateDifficulty(request: UpdateDifficultyRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'UpdateDifficulty',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Изменить статус
	 */
	async UpdateStatus(query: TaskUpdateStatusRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'UpdateStatus',
			Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Метод обновления типа задачи
	 */
	async UpdateTaskType(request: UpdateTaskTypeRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'UpdateTaskType',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Поменять порядковый номер
	 */
	async UpdateNumber(request: TaskUpdateNumberRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'UpdateNumber',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Поменять дату конца
	 */
	async UpdateDateEnd(request: TaskUpdateDateEndRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'UpdateDateEnd',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Создать задачу
	 */
	async TaskCreate(query: TaskCreateRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'TaskCreate',
			Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Удаление
	 */
	async Remove(request: TaskRemoveRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'Remove',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Сменить привязку спринта
	 */
	async UpdateSprint(request: TaskUpdateSprintRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'UpdateSprint',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Поменять исполнителя
	 */
	async UpdatePerformers(request: PerformersUpdateRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'UpdatePerformers',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Изменение наблюдателей к задаче
	 */
	async UpdateObserver(request: ObserverUpdateRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'UpdateObserver',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Обновление тегов задачи
	 */
	async UpdateTagsInTask(request: AddTagsRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'UpdateTagsInTask',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Добавить оценку времени
	 */
	async UpsertEstimatePerformer(request: EstimatePerformerSaveRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'UpsertEstimatePerformer',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Добавить файл к задачи
	 */
	async AddFile(request: AttachFileTaskRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'AddFile',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Удалить файлы пользователя
	 */
	async RemoveFiles(request: RemoveFilesTaskRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'RemoveFiles',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Убирает подзадачу из задачи
	 */
	async RemoveSubtask(query: RemoveSubtaskRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'RemoveSubtask',
			Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Добавление подзадачи
	 */
	async AttachSubtask(query: AttachSubtaskRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'AttachSubtask',
			Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * Изменить описание
	 */
	async updateDescriptionAsync(query: TaskUpdateDescriptionRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'UpdateDescription',
				Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Изменить название задачи
	 */
	async updateNameAsync(query: TaskUpdateNameRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'UpdateName',
				Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Изменить приоритет
	 */
	async updatePriorityAsync(query: TaskUpdatePriorityRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'UpdatePriority',
				Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Обновление сложности задачи
	 */
	async updateDifficultyAsync(request: UpdateDifficultyRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'UpdateDifficulty',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Изменить статус
	 */
	async updateStatusAsync(query: TaskUpdateStatusRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'UpdateStatus',
				Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Метод обновления типа задачи
	 */
	async updateTaskTypeAsync(request: UpdateTaskTypeRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'UpdateTaskType',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Поменять порядковый номер
	 */
	async updateNumberAsync(request: TaskUpdateNumberRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'UpdateNumber',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Поменять дату конца
	 */
	async updateDateEndAsync(request: TaskUpdateDateEndRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'UpdateDateEnd',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Создать задачу
	 */
	async taskCreateAsync(query: TaskCreateRequest): Promise<TaskCreateResponse> {
		return new Promise<TaskCreateResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'TaskCreate',
				Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
				Callback: (response: WsResponseModelT<TaskCreateResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as TaskCreateResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Удаление
	 */
	async removeAsync(request: TaskRemoveRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'Remove',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Сменить привязку спринта
	 */
	async updateSprintAsync(request: TaskUpdateSprintRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'UpdateSprint',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Поменять исполнителя
	 */
	async updatePerformersAsync(request: PerformersUpdateRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'UpdatePerformers',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Изменение наблюдателей к задаче
	 */
	async updateObserverAsync(request: ObserverUpdateRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'UpdateObserver',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Обновление тегов задачи
	 */
	async updateTagsInTaskAsync(request: AddTagsRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'UpdateTagsInTask',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Добавить оценку времени
	 */
	async upsertEstimatePerformerAsync(request: EstimatePerformerSaveRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'UpsertEstimatePerformer',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Добавить файл к задачи
	 */
	async addFileAsync(request: AttachFileTaskRequest): Promise<String> {
		return new Promise<String>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'AddFile',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<String>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as String)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Удалить файлы пользователя
	 */
	async removeFilesAsync(request: RemoveFilesTaskRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'RemoveFiles',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Убирает подзадачу из задачи
	 */
	async removeSubtaskAsync(query: RemoveSubtaskRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'RemoveSubtask',
				Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Добавление подзадачи
	 */
	async attachSubtaskAsync(query: AttachSubtaskRequest): Promise<TaskShortInfo> {
		return new Promise<TaskShortInfo>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'AttachSubtask',
				Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
				Callback: (response: WsResponseModelT<TaskShortInfo>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as TaskShortInfo)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}